import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: null,
    isDark: false,//localStorage.getItem('isDark') == '1',
    currentImage: null,
    unread: {},
    lastRequest: moment(),
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
